module.exports = __webpack_public_path__ + "static/media/bg.1172f066.jpg";